/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-08-17 09:54:56
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2023-09-21 18:04:12
 * @FilePath: \vue-hepha-order\src\directive\permission.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    install(app){
        app.directive('permission',{
            mounted(el,binding){
                let type = binding.value || ''
                let status = false
                let permissionBtns = []
                if(sessionStorage.getItem('permissionBtns')){
                    permissionBtns = JSON.parse(sessionStorage.getItem('permissionBtns'))
                }
                ///这里表示用户所拥有的所有权限
                // console.log(permissionBtns, 'permissionBtns bbbbb')
                permissionBtns.forEach((item) => {
                    if (type == item) {
                        status = true
                    }
                })
                
                if (!status) {
                    el.style.display = 'none'
                }
            }
        })
    }
}